export default __webpack_public_path__ + "static/media/roomreserve.64d9a0f5.svg";